import { Helmet } from "react-helmet-async";

export default function Privacy() {
  return (
    <main className="mx-auto w-full max-w-3xl px-4 py-8 space-y-4">
      <Helmet>
        <title>Privacy Policy | FANZ</title>
        <meta name="description" content="Privacy policy and data practices." />
        <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : 'https://example.com/privacy'} />
      </Helmet>
      <h1 className="text-2xl font-semibold">Privacy Policy</h1>
      <p className="text-sm text-muted-foreground">We respect your privacy. This is placeholder copy.</p>
    </main>
  );
}
